export default __webpack_public_path__ + "static/media/mo-lottery-paper.634dc4bc.webp";